import { ORPCError } from "@orpc/client";
import { useRouteError } from "react-router";
import { ProfileNotFound } from "./ProfileNotFound.tsx";

export function ProfileErrorBoundary() {
    const error = useRouteError();

    if (error instanceof ORPCError && error.code === "NOT_FOUND") {
        return <ProfileNotFound />;
    }

    throw error;
}
